module.exports = new __parcel__URL__("ai-platform-unified-svgrepo-com.c3f55570.svg").toString();